import { render, staticRenderFns } from "./SessionTagList.vue?vue&type=template&id=6533dfc0"
import script from "./SessionTagList.vue?vue&type=script&lang=ts"
export * from "./SessionTagList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports